const rcLoader = {
  async bind(el, binding) {
    await new Promise(resolve => setTimeout(resolve, 0));
    el.classList.add('load-wrapper');
    const pendingDiv = document.createElement('div');
    pendingDiv.classList.add('isPending');
    pendingDiv.style['--topOffset'] = `calc(50% + ${el.scrollTop}px)`;
    if (binding.value) {
      pendingDiv.style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      el.classList.remove('load-content');
    }
    el.append(pendingDiv);
  },
  async componentUpdated(el, binding) {
    await new Promise(resolve => setTimeout(resolve, 0));
    if (binding.value) {
      const pendingDiv = el.querySelectorAll(':scope > .isPending');
      pendingDiv[0].style.setProperty('--topOffset', `calc(50% + ${el.scrollTop}px)`);
      el.classList.add('load-content');
    } else {
      const pendingDiv = el.querySelectorAll(':scope > .isPending');
      if (pendingDiv[1]) {
        pendingDiv[1].parentNode.removeChild(pendingDiv[1]);
      }
      el.classList.remove('load-content');
    }
  },
};

export { rcLoader };